import { Switch } from 'antd';
import styled from 'styled-components';

export const SwitchWrapper = styled(Switch)``;
